import { Wallet, CreditCard, Plus, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AccountHorizontalScroll } from "./AccountHorizontalScroll";
import { CreditCardHorizontalScroll } from "./CreditCardHorizontalScroll";
import type { DragEndEvent } from "@dnd-kit/core";

interface DashboardAccountsSectionProps {
  bankAccounts: any[];
  creditCards: any[];
  onAddAccount: () => void;
  onAddCreditCard?: () => void;
  onEditAccount: (account: any) => void;
  onAddTransaction: (accountId: string) => void;
  onViewInvoice: (accountId: string) => void;
  onImport: (accountId: string) => void;
  onAddExpense: (accountId: string) => void;
  onAccountDragEnd: (event: DragEndEvent) => void;
  onCreditCardDragEnd: (event: DragEndEvent) => void;
  formatCurrency: (value: number) => string;
  creditCardRefreshKey: number;
  creditCardLocked?: boolean;
  allAccountsLocked?: boolean;
}

export function DashboardAccountsSection({
  bankAccounts,
  creditCards,
  onAddAccount,
  onAddCreditCard,
  onEditAccount,
  onAddTransaction,
  onViewInvoice,
  onImport,
  onAddExpense,
  onAccountDragEnd,
  onCreditCardDragEnd,
  formatCurrency,
  creditCardRefreshKey,
  creditCardLocked = false,
  allAccountsLocked = false,
}: DashboardAccountsSectionProps) {
  return (
    <div className="space-y-6">
      {/* Bank Accounts */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <Wallet className="h-4 w-4" />
            Minhas Contas
          </h2>
          <Button variant="outline" size="sm" onClick={onAddAccount}>
            {allAccountsLocked ? (
              <Lock className="h-4 w-4 mr-2 text-muted-foreground" />
            ) : (
              <Plus className="h-4 w-4 mr-2" />
            )}
            <span className="hidden sm:inline">Adicionar</span>
          </Button>
        </div>
        <AccountHorizontalScroll
          accounts={bankAccounts}
          onAddAccount={onAddAccount}
          onEditAccount={onEditAccount}
          onAddTransaction={onAddTransaction}
          onDragEnd={onAccountDragEnd}
          formatCurrency={formatCurrency}
          locked={allAccountsLocked}
        />
      </div>

      {/* Credit Cards */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            Cartoes de Credito
          </h2>
          <Button variant="outline" size="sm" onClick={onAddCreditCard || onAddAccount}>
            {creditCardLocked ? (
              <Lock className="h-4 w-4 mr-2 text-muted-foreground" />
            ) : (
              <Plus className="h-4 w-4 mr-2" />
            )}
            <span className="hidden sm:inline">Adicionar</span>
          </Button>
        </div>
        <CreditCardHorizontalScroll
          creditCards={creditCards}
          onAddCard={onAddCreditCard || onAddAccount}
          onEditCard={onEditAccount}
          onViewInvoice={onViewInvoice}
          onImport={onImport}
          onAddExpense={onAddExpense}
          onDragEnd={onCreditCardDragEnd}
          formatCurrency={formatCurrency}
          refreshKey={creditCardRefreshKey}
          locked={creditCardLocked}
        />
      </div>
    </div>
  );
}
